"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var getViteMetroPluginOptions_exports = {};
__export(getViteMetroPluginOptions_exports, {
  getViteMetroPluginOptions: () => getViteMetroPluginOptions
});
module.exports = __toCommonJS(getViteMetroPluginOptions_exports);
var import_babel_preset = require("../babel-preset");
var import_buildOneMetroResolverOverrides = require("./buildOneMetroResolverOverrides");
function getViteMetroPluginOptions(param) {
  var { projectRoot, relativeRouterRoot, ignoredRouteFiles, linking, userDefaultConfigOverrides, setupFile } = param;
  var applyOneResolverOverrides = (0, import_buildOneMetroResolverOverrides.buildOneMetroResolverOverrides)({
    projectRoot
  });
  return {
    oneViteMetroBabelConfig: true,
    defaultConfigOverrides: function(defaultConfig) {
      var config = applyOneResolverOverrides(defaultConfig);
      if (typeof userDefaultConfigOverrides === "function") {
        config = userDefaultConfigOverrides(config);
      }
      return config;
    },
    babelConfig: {
      plugins: (0, import_babel_preset.buildOneBabelPlugins)({
        projectRoot,
        relativeRouterRoot,
        ignoredRouteFiles,
        linking,
        setupFile,
        // vite path injects import-meta-env-plugin separately via the
        // metro server transformFile hook using the user's vite `define`.
        includeImportMetaEnv: false
      })
    }
  };
}
//# sourceMappingURL=getViteMetroPluginOptions.js.map
